import React, {useState} from 'react';
import {Tabs, Tab} from '@mui/material';
import NetworkDashboardShell from '../components/NetworkDashboard.comp';
import {ORANGE} from '../components/widgets.comp';
import ReadinessOverviewTab from '../tabs/ReadinessOverview.tab';
import ItemProfileTab from '../tabs/ItemProfile.tab';
import BySchoolTab from '../tabs/BySchool.tab';

const tabSx = {
    borderBottom: '1px solid #E5E7EB', mb: 3,
    '& .MuiTab-root': {textTransform: 'none', fontWeight: 600, fontSize: '14px', color: '#6A7282', px: 2, whiteSpace: 'nowrap', minHeight: 48},
    '& .Mui-selected': {color: `${ORANGE} !important`},
};

const ReadinessPage = () => {
    const [tab, setTab] = useState(0);
    return (
        <NetworkDashboardShell
            needsAssessmentResults
            tabs={
                <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto"
                      TabIndicatorProps={{style: {backgroundColor: ORANGE}}} sx={tabSx}>
                    <Tab label="Overview"/>
                    <Tab label="Item Profile"/>
                    <Tab label="By School"/>
                </Tabs>
            }
        >
            {tab === 0 && <ReadinessOverviewTab/>}
            {tab === 1 && <ItemProfileTab/>}
            {tab === 2 && <BySchoolTab/>}
        </NetworkDashboardShell>
    );
};

export default ReadinessPage;
